export default [
  {
    path: '/card',
    name: 'CardQuery',
    component: () => import('@/views/card'),
    meta: {
      title: '卡片查询',
      
    }
  },
  {
    path: '/card/list',
    name: 'CardList',
    component: () => import('@/views/card/list'),
    meta: {
      title: '查询结果',
      
    }
  }
] 